import React from "react"
import moment from "moment"
import "./calendar.css";
import styled from 'styled-components';
import ArrowRight from '../Images/ChevronRight';
import ArrowLeft from '../Images/ChevronLeft';
import BackButton from '../Images/BackButton';
import {months} from '../../constants'
import { checkNextMonthPublishDatePresent, getDateClassNameForSpecificDate, getPublishedDaysForSpecificMonth } from "../../lib/utils";
import CrossIcon from "../Images/CrossIcon";

const ArrowRightIcon = styled(ArrowRight)`
  // align-self: center;
  fill: var(--storm-op-64);
  height: 24px;
  width: 24px;
  cursor:pointer;
`
const ArrowLeftIcon = styled(ArrowLeft)`
  // align-self: center;
  fill: var(--storm-op-64);
  height: 24px;
  width: 24px;
  cursor:pointer;
`
const BackButtonIcon=styled(BackButton)`
  cursor:pointer;
`
export default class ScheduleCalendar extends React.Component {
  weekdayshort = moment.weekdaysShort();

  state = {
    showCalendarTable: true,
    showMonthTable: false,
    dateObject: moment(),
    allmonths: moment.months(),
    showYearNav: false,
    selectedDay: null,
    showPreviousMonthIcon : false,
    errorMsg: false
  };
  
  daysInMonth = () => {
    return this.state.dateObject.daysInMonth();
  };

  year = () => {
    return this.state.dateObject.format("Y");
  };

  currentDay = () => {
    return this.state.dateObject.format("D");
  };

  firstDayOfMonth = () => {
    const dateObject = this.state.dateObject;
    const firstDay = moment(dateObject)
      .startOf("month")
      .format("d"); // Day of week 0...1..5...6
    return firstDay;
  };

  month = () => {
    return this.state.dateObject.format("MMMM");
  };

  showMonth = (e, month) => {
    this.setState({
      showMonthTable: !this.state.showMonthTable,
      showCalendarTable: !this.state.showCalendarTable
    });
  };

  setMonth = month => {
    const monthNo = this.state.allmonths.indexOf(month);
    let dateObject = Object.assign({}, this.state.dateObject);
    dateObject = moment(dateObject).set("month", monthNo);
    this.setState({
      dateObject: dateObject,
      showMonthTable: !this.state.showMonthTable,
      showCalendarTable: !this.state.showCalendarTable
    });
  };

  decreasetMonth = month => {
    if(new Date(this.state.dateObject).getMonth()!==new Date().getMonth() || new Date(this.state.dateObject).getFullYear()!==new Date().getFullYear())
    {
      let monthNo = this.state.allmonths.indexOf(month);
      monthNo--;
      let dateObject = Object.assign({}, this.state.dateObject);
      dateObject = moment(dateObject).set("month", monthNo);
      this.setState({
        dateObject: dateObject,
        showMonthTable: !this.state.showMonthTable,
        showPreviousMonthIcon : true
      });
    }
  };

  increasetMonth = month => {
    let monthNo = this.state.allmonths.indexOf(month);
    monthNo++;
    let dateObject = Object.assign({}, this.state.dateObject);
    dateObject = moment(dateObject).set("month", monthNo);
    this.setState({
      dateObject: dateObject,
      showMonthTable: !this.state.showMonthTable,
      showPreviousMonthIcon : true
    });
  };

  MonthList = props => {
    const months = props.data.map(d => (
        <td
          key={d}
          className="calendar-month"
          onClick={e => {
            this.setMonth(d);
          }}
        >
          <span>{d}</span>
        </td>
    ));
    const rows = [];
    let cells = [];

    months.forEach((row, i) => {
      if (i % 3 !== 0 || i === 0) {
        cells.push(row);
      } else {
        rows.push(cells);
        cells = [];
        cells.push(row);
      }
    });
    rows.push(cells);
    const monthlist = rows.map((d, i) => {
      return <tr>{d}</tr>;
    });

    return (
      <table className="calendar-month">
        <thead>
          <tr>
            <th colSpan="4">Select a Month</th>
          </tr>
        </thead>
        <tbody>{monthlist}</tbody>
      </table>
    );
  };

  showYearEditor = () => {
    this.setState({
      showYearNav: true,
      showCalendarTable: !this.state.showCalendarTable
    });
  };

  onPrev = () => {
    let curr = "";
    if (this.state.showMonthTable === true) {
      curr = "year";
    } else {
      curr = "month";
    }
    this.setState({
      dateObject: this.state.dateObject.subtract(1, curr)
    });
  };

  onNext = () => {
    let curr = "";
    if (this.state.showMonthTable === true) {
      curr = "year";
    } else {
      curr = "month";
    }
    this.setState({
      dateObject: this.state.dateObject.add(1, curr)
    });
  };

  setYear = year => {
    // alert(year)
    let dateObject = Object.assign({}, this.state.dateObject);
    dateObject = moment(dateObject).set("year", year);
    this.setState({
      dateObject: dateObject,
      showYearNav: !this.state.showYearNav,
      showMonthTable: !this.state.showMonthTable
    });
  };

  onYearChange = e => {
    this.setYear(e.target.value);
  };

  getDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = moment(startDate);
    var lastDate = moment(stopDate);
    while (currentDate <= lastDate) {
      dateArray.push(moment(currentDate).format("YYYY"));
      currentDate = moment(currentDate).add(1, "year");
    }
    return dateArray;
  }

  YearTable = props => {
    const months = [];
    const nextten = moment()
      .set("year", props)
      .add("year", 12)
      .format("Y");

    const tenyear = this.getDates(props, nextten);

    tenyear.map(data => {
      months.push(
        <td
          key={data}
          className="calendar-month"
          onClick={e => {
            this.setYear(data);
          }}
        >
          <span>{data}</span>
        </td>
      );
    });
    const rows = [];
    let cells = [];

    months.forEach((row, i) => {
      if (i % 3 !== 0 || i === 0) {
        cells.push(row);
      } else {
        rows.push(cells);
        cells = [];
        cells.push(row);
      }
    });
    rows.push(cells);
    const yearlist = rows.map((d, i) => {
      return <tr>{d}</tr>;
    });

    return (
      <table className="calendar-month">
        <thead>
          <tr>
            <th colSpan="4">Select a Year</th>
          </tr>
        </thead>
        <tbody>{yearlist}</tbody>
      </table>
    );
  };

  onDayClick = (e, d,selected) => {
    if(selected.trim() ==='highlight'){
      this.setState({
        errorMsg : true
      })
      setTimeout(() => {
        this.setState({
          errorMsg : false
        })
      },5000)
    }
    if(selected.trim()!=='highlight' && !this.props.disabledTimer){
      this.setState(
        {
          selectedDay: d
        }
      );
      this.props.setUserCalendarDate(`${d}-${months[(this.state.dateObject.format('MM')-1)]}-${this.state.dateObject.format("YYYY")}`);
      this.props.close();
      // this.props.openPublishPopup();
    }
  };

  getHighlightedDate(date){
    if(this.state.dateObject.format('MM') === new Date().getMonth()+1 && new Date(this.state.dateObject).getFullYear() === new Date().getFullYear())
    {
      const dates=[];
      Array.from(Array(date).keys()).forEach(elm=>{
        if(elm+1<10)
          dates.push(new Date(`${new Date().getFullYear()}-${new Date().getMonth()+1}-0${elm+1}`).toISOString());
        else
          dates.push(new Date(`${new Date().getFullYear()}-${new Date().getMonth()+1}-${elm+1}`).toISOString());
      })
      return dates;
    }
    else{
        return [];
    }
  }
  
  render() {
    const weekdayshortname = this.weekdayshort.map(day => {
      return <th key={day.toUpperCase()}>{day}</th>;
    });
    const blanks = [];
    for (let i = 0; i < this.firstDayOfMonth(); i++) {
      blanks.push(<td key={"calender-day-empty-" + i} className="calendar-day empty">{""}</td>);
    }
    const daysInMonth = [];
    const todaysDate = new Date()
    const publishedDatesForMonth = getPublishedDaysForSpecificMonth(this.props.publishedDates, this.month(), this.year())
    const isNextMonthPublishDatePresent = checkNextMonthPublishDatePresent(this.props.publishedDates, this.month(), this.year())
    for (let d = 1; d <= this.daysInMonth(); d++) {      
      const currentDay = d == this.currentDay() && months[todaysDate.getMonth()] === this.month().substr(0,3) && todaysDate.getFullYear() ? "today" : "";
      const classColorForDate = getDateClassNameForSpecificDate(d,isNextMonthPublishDatePresent,publishedDatesForMonth)
      const selected = classColorForDate === 'missed' || classColorForDate === 'published' ? 'highlight' : '';
      // if(d === publishedDatesForMonth[publishedDatesForMonth.length -1] && !isNextMonthPublishDatePresent){
      //   selected = ''
      // }
      daysInMonth.push(
        <td key={"calendar-day-" + d} className={`calendar-day ${currentDay} ${classColorForDate}`}>
          <span 
            onClick={e => {
              this.onDayClick(e, d,selected);
            }}
          >
            {d}
          </span>
        </td>
      );
    }
    var totalSlots = [...blanks, ...daysInMonth];
    const rows = [];
    let cells = [];

    totalSlots.forEach((row, i) => {
      if (i % 7 !== 0) {
        cells.push(row);
      } else {
        rows.push(cells);
        cells = [];
        cells.push(row);
      }
      if (i === totalSlots.length - 1) {
        // let insertRow = cells.slice();
        rows.push(cells);
      }
    });

    const daysinmonth = rows.map((d, i) => {
      return <tr key={"days-in-month-" + d + i} className={`calendar-day`}>{d}</tr>;
    });

    return (
      <div className="tail-datetime-calendar">
        <div className="month-year-label-div">
        <div className="back-button"> 
        <BackButtonIcon onClick={()=>this.props.onBackClick()}></BackButtonIcon>
        {/* <ArrowLeftIcon onClick={()=>this.props.onBackClick()}></ArrowLeftIcon> */}
        </div>
        <div className="calendarTitle">
       {this.state.showPreviousMonthIcon && <ArrowLeftIcon onClick={()=>this.decreasetMonth(this.month())}></ArrowLeftIcon>}
       <div className="calendar-navi">
              {this.month()} {this.year()}
        </div><ArrowRightIcon onClick={()=>this.increasetMonth(this.month())}></ArrowRightIcon>
        </div>
        </div>
        {/* <button onClick={()=>this.decreasetMonth(this.month())}>decre</button>
        <button onClick={()=>this.increasetMonth(this.month())}>incre</button> */}
        {/* <div className="calendar-date">
          {this.state.showYearNav && <this.YearTable props={this.year()} />}
          {this.state.showMonthTable && (
            <this.MonthList data={moment.months()} />
          )}
        </div> */}

        {this.state.showCalendarTable && (
          <div className="calendar-date">
            <table className="calendar-day">
              <thead>
                <tr>{weekdayshortname}</tr>
              </thead>
              <tbody>{daysinmonth}</tbody>
            </table>
          </div>
        )}
        <div className="labels">
            <div className="label-desc"><div className="label-box-green" />Already Scheduled</div>
            <div className="label-desc"><div className="label-box-red" />Missed Dates</div>
        </div>
        {this.state.errorMsg && <div className="error-msg">
          <span>Cannot select a date before the lastest scheduled chapter.</span>
          <CrossIcon width="24" height="24" onClick={() => this.setState({ errorMsg : false })}/>  
        </div>}
      </div>
    );
  }
}